const styles = {
    bg: '#131313',
    primary: '#9e1313',
    primaryDarken: '#5B0B0B'
}
export default styles;